import client from "../config/AxiosConfig";

export const Login = async data => client.post("/auth/login", data);

export const RecoverAccount = async data => client.post("/auth/recover", data);

export const ResetPassword = async data => client.post("/auth/recover-confirmation", data);

export const RegisterConfirmation = async data => client.post("/auth/register", data);
